export const getStableUniqueIds = (ids: Array<string | undefined | null>) =>
  [...new Set(ids.filter((id): id is string => Boolean(id)))].sort();
